import { makeStyles } from '@material-ui/core';
import * as colours from '../../../abstracts/colours';
import constants from '../../../abstracts/constants';
import styled from 'styled-components';

export const StyledLabel = styled.div`
  color: ${colours.black};
  font-family: ${constants.sourceSansPro};
  font-size: 20px;
  margin-left: 14px;
  line-height: 1.5;
  height: 32px;
`;

export const StyledHelperMessage = styled.span`
  height: 20px;
  font-size: 14px;
`;

export const StyledTextFieldContainer = styled.div`
  min-height: 87px;
  height: 100%;
`;

const useStyles = makeStyles({
  endAdornment: {
    fontSize: 12,
    fontWeight: 'bold',
    width: 30,
    color: colours.scienceBlue,
    fontFamily: constants.sourceSansPro,
  },
  input: {
    '& .MuiInputBase-input': {
      fontFamily: constants.sourceSansPro,
      fontSize: 20,
      height: 32,
      padding: 16,
      '&::placeholder': {
        color: colours.brownGrey,
        opacity: 0.9,
      },
    },
    '& .Mui-disabled .MuiInputBase-input': {
      color: colours.xanadu,
    },
    '& .Mui-focused .MuiInputBase-input::placeholder': {
      color: colours.nevada,
      opacity: 0.5,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.iron,
      borderWidth: 2,
      borderRadius: 10,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.scienceBlue,
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.scienceBlue,
    },
    '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.iron,
      backgroundColor: colours.silverTwo,
      opacity: 0.15,
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.cherry,
    },
    '&:hover.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.cherry,
    },
    '& .MuiFormHelperText-root': {
      fontFamily: constants.sourceSansPro,
      marginTop: 0,
      letterSpacing: 'normal',
      color: colours.abbey,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: colours.cherry,
    },
  },
  textarea: {
    '& .MuiInputBase-input': {
      fontFamily: constants.sourceSansPro,
      fontSize: 20,
      height: 128,
      padding: 16,
      '&::placeholder': {
        color: colours.brownGrey,
        opacity: 0.9,
      },
    },
    '& .MuiOutlinedInput-multiline': {
      padding: 0,
    },
    '& .Mui-disabled .MuiInputBase-input': {
      color: colours.xanadu,
    },
    '& .Mui-focused .MuiInputBase-input::placeholder': {
      color: colours.nevada,
      opacity: 0.5,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.iron,
      borderWidth: 2,
      borderRadius: 10,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.scienceBlue,
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.scienceBlue,
    },
    '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.iron,
      backgroundColor: colours.silverTwo,
      opacity: 0.15,
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.cherry,
    },
    '&:hover.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: colours.cherry,
    },
    '& .MuiFormHelperText-root': {
      fontFamily: constants.sourceSansPro,
      marginTop: 0,
      letterSpacing: 'normal',
      color: colours.abbey,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: colours.cherry,
    },
  },
});

export default useStyles;
